module.exports = __webpack_public_path__ + "img/chip.f99ef6fa.svg";